export default __webpack_public_path__ + "static/media/googlePlay.b5f9c66b.svg";